import React from 'react';
import { FaTwitter, FaFacebookSquare, FaPinterest, FaEnvelope } from 'react-icons/fa';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router';
import AppSettings from '../../configs/appSettings';
import Button from 'react-bootstrap/Button';
import {
  useProductDetail,
  useProductImages,
  useAttributes,
  useInventories,
  useMarketingSentence,
  useRelatedProducts,
  useDescription,
} from '../../services/useProductDetail';
import './productPage.css';
import StatusPill from '../../components/statusPill';
import DetailsSection from '../../components/details';
import WebReadyImages from '../../components/webReadyImages';
import HighResImages from '../../components/highResImages';
import ReferencesSection from '../../components/references';
import ReviewsSection from '../../components/reviews';
import RelatedProduts from '../../components/relatedProducts';
import Inventory from '../../components/inventory';
import { ImageType } from '../../models/image';

import { useCategoryTagbySKU } from '../../services/useCurrentCategoryIds';
import { ProductBreadcrumbNavigation } from '../../components/breadcrumbNavigation';
import { useCategoryTag } from '../../services/useCategoryTree';
import { Modal } from 'react-bootstrap';

const ProductPage = () => {
  //add logic here for db call based on the item ID
  //This dataset will give you all the props to pass into the components on this page

  //delete the variables below this line once the API is imported ------------------------------------------

  let { sku } = useParams();
  let modelNum = sku || '';

  useCategoryTagbySKU(sku);
  const [currentView, setCurrentView] = useState('details');
  const [slideImages, setSlideImages] = useState<any[]>([]);
  const [mainImageUrl, setMainImageUrl] = useState('');
  const [imageId, setImageId] = useState('');
  const { data: categoryTags } = useCategoryTag(sku!);
  const { productDetails, error, isLoading } = useProductDetail(modelNum);
  const { productImages } = useProductImages(modelNum, ImageType.WebReady);
  const { productImages: highResImages } = useProductImages(modelNum, ImageType.HighResolution);
  const attributes = useAttributes(modelNum);
  const inventories = useInventories(modelNum);
  const marketingSentences = useMarketingSentence(modelNum);
  const description = useDescription(modelNum);
  const relations = useRelatedProducts(modelNum);
  const displayName = React.useMemo(() => productDetails && productDetails.name, [productDetails]);
  //const catSheets = useCatSheets(modelNum);
  const [showCatSheets, setShowCatSheets] = useState(false);

  let url = AppSettings.BaseUrl + '/model/' + modelNum;

  useEffect(() => {
    //Pull the first 4 web ready images for preview squares
    var _slideImages: any[] = [];
    if (productImages) {
      if (productImages.length > 0) {
        setMainImageUrl(productImages[0].ImageUrl);
        setImageId(productImages[0].ImageId);
      }
      if (productImages.length <= 3) {
        _slideImages = productImages;
      } else {
        for (var i = 0; i <= 3; i++) {
          _slideImages.push(productImages[i]);
        }
      }
      setSlideImages(_slideImages);
    }
  }, [productImages]);

  if (!productDetails) {
    return null;
  }

  return (
    <>
      {categoryTags && (
        <ProductBreadcrumbNavigation
          product={{
            sku: sku!,
            name: productDetails?.name,
            categoryTagId: categoryTags[0]?.categoryTagId,
          }}
        />
      )}
      <div className="product-page-upper">
        <div id="large-screen-title-section">
          <span className="product-page-displayName">{displayName}</span>
          <div className="product-catSheet-and-share-container">
            <Button
              variant="link"
              className="bg-transparent ps-0"
              onClick={() => setShowCatSheets(true)}
            >
              Download Cat Sheets
            </Button>
            <div className="product-share d-flex align-items-center">
              <span className="share">Share</span>
              <a
                href={'https://www.facebook.com/sharer/sharer.php?u=' + url}
                link-name="Social Share – Facebook"
                link-type="exit link"
                target="_blank"
                aria-label="Share to Facebook"
                title="Share to Facebook"
              >
                <FaFacebookSquare />
              </a>
              <a
                href="https://twitter.com/share"
                link-name="Social Share – Twitter"
                link-type="exit link"
                target="_blank"
                aria-label="Share to Twitter"
                title="Share to Twitter"
              >
                <FaTwitter />
              </a>
              {mainImageUrl && (
                <a
                  aria-label="Save to Pinterest"
                  data-pin-custom="true"
                  title="Save to Pinterest"
                  id="pinterestButton"
                  href={
                    'https://www.pinterest.com/pin/create/button/?url=' +
                    url +
                    '&media=' +
                    mainImageUrl +
                    '&description=' +
                    encodeURIComponent(displayName)
                  }
                  link-name="Social Follow – Pinterest"
                  link-type="exit link"
                  target="_blank"
                >
                  <FaPinterest />
                </a>
              )}
              <a
                href={
                  'mailto:?subject=I%20thought%20you%20might%20be%20interested%20in%20this...&body=I%20was%20visiting%20www.lifetime.com%20and%20I%20found%20the ' +
                  encodeURIComponent(displayName) +
                  '.%20You%20can%20find%20out%20more%20about%20it%20at%20this%20link:%20' +
                  url
                }
                title="Email a friend"
                link-name="Product Detail - Email"
                link-type="Other"
                aria-label="Email a friend"
                target="_blank"
              >
                <FaEnvelope />
              </a>
            </div>
          </div>

          <span className="product-page-modelNum"> Model: {modelNum}</span>
          <StatusPill status={productDetails.state} />
        </div>
        <div className="mobile-image-container">
          <img className="product-page-main-image" src={mainImageUrl} />
        </div>
        <div className="product-image-preview-container">
          {slideImages &&
            slideImages.map(function (img: any) {
              return (
                <img
                  key={img.ImageId}
                  className={`${
                    imageId == img.ImageId
                      ? 'product-image-preview-img active'
                      : 'product-image-preview-img'
                  }`}
                  src={img.ImageUrl}
                  onMouseOver={() => {
                    setMainImageUrl(img.ImageUrl);
                    setImageId(img.ImageId);
                  }}
                />
              );
            })}
        </div>
      </div>
      <div className="product-page-lower">
        <div className="product-navbar">
          <span
            onClick={() => setCurrentView('details')}
            className={`${currentView == 'details' ? 'text-primary' : ''}`}
          >
            DETAILS
          </span>
          <span
            onClick={() => setCurrentView('webReadyImages')}
            className={`${currentView == 'webReadyImages' ? 'text-primary' : ''}`}
          >
            WEB READY IMAGES
          </span>
          <span
            onClick={() => setCurrentView('highResImages')}
            className={`${currentView == 'highResImages' ? 'text-primary' : ''}`}
          >
            HIGH RES IMAGES
          </span>
          <span
            onClick={() => setCurrentView('inventories')}
            className={`${currentView == 'inventories' ? 'text-primary' : ''}`}
          >
            INVENTORY
          </span>
          <span
            onClick={() => setCurrentView('references')}
            className={`${currentView == 'references' ? 'text-primary' : ''}`}
          >
            REFERENCES
          </span>
          <span
            onClick={() => setCurrentView('reviews')}
            className={`${currentView == 'reviews' ? 'text-primary' : ''}`}
          >
            REVIEWS
          </span>
          <span
            onClick={() => setCurrentView('related')}
            className={`${currentView == 'related' ? 'text-primary' : ''}`}
          >
            RELATED PRODUCTS
          </span>
        </div>

        {(() => {
          switch (currentView) {
            case 'details':
              return (
                <DetailsSection
                  marketingSentences={marketingSentences}
                  attributes={attributes}
                  description={description}
                />
              );
            case 'webReadyImages':
              return <WebReadyImages productImages={productImages} sku={modelNum} />;
            case 'highResImages':
              return <HighResImages productImages={highResImages} sku={modelNum} />;
            case 'inventories':
              return <Inventory sku={modelNum} inventories={inventories} />;
            case 'references':
              return <ReferencesSection sku={modelNum} />;
            case 'reviews':
              return <ReviewsSection sku={modelNum} />;
            case 'related':
              return <RelatedProduts relations={relations} sku={modelNum} />;
            default:
              return (
                <DetailsSection marketingSentences={marketingSentences} attributes={attributes} />
              );
          }
        })()}
      </div>
      <Modal show={showCatSheets} centered onHide={() => setShowCatSheets(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Cat Sheets</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>To request a CAT sheet, please contact PMM or submit a work request.</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCatSheets(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProductPage;
